export default () => {
  const form = document.querySelector('.pupil-refund-request');
  if (!form) return;

  const updateTabindices = () => {
    form.querySelectorAll('input, select, textarea').forEach(input => {
      const inClosed = input.closest('.pupil-toggle:not(.open)');
      if (inClosed) {
        input.setAttribute('tabindex', '-1');
      } else {
        input.removeAttribute('tabindex');
      }
    });
  };

  form.querySelectorAll('.pupil-refund-title').forEach(title => {
    title.addEventListener('click', () => {
      title.closest('.pupil-toggle').classList.toggle('open');
      updateTabindices();
    });
  });

  updateTabindices();
};
